<template>
    <v-app>
        Prepared to download 191105-patch : {{ stagedCount }}, Prepared to download 191106: {{ preparedCount }}
        <hr/>
        Reporting as gb5k-patch version ({{ gb5patchCount }}): {{ versionsgb5patch }}
        <hr/>
        Reporting as gb5m version ({{ gb5mCount }}): {{ versionsgb5m }}
        <hr/>
        Reporting as gb5k version ({{ gb5kCount }}): {{ versionsgb5k }}
    </v-app>
</template>

<script>
    import Vue from 'vue'

    const fb = require('../firebase')

    export default {
        name: "DeviceVersion",
        data() {
            return {
                group: {},
                devices: [],
                versions: {},
                versionsgb5k: {},
                versionsgb5patch: {},
                versionsgb5m: {},
                preparedDevices: {},
                stagedDevices: {},
                staged: 0
            }
        },
        computed: {
            gb5kCount() {
                let count = 0
                Object.keys(this.versionsgb5k).forEach(function () {
                    count = count + 1
                })
                return count
            },
            gb5patchCount() {
                let count = 0
                Object.keys(this.versionsgb5patch).forEach(function () {
                    count = count + 1
                })
                return count
            },
            gb5mCount() {
                let count = 0
                Object.keys(this.versionsgb5m).forEach(function () {
                    count = count + 1
                })
                return count
            },
            stagedCount() {
                let count = 0
                Object.keys(this.stagedDevices).forEach(function () {
                    count = count + 1
                })
                return count
            },
            preparedCount() {
                let count = 0
                Object.keys(this.preparedDevices).forEach(function () {
                    count = count + 1
                })
                return count
            }
        },
        mounted() {
            this.fetchGroup()
        },
        methods: {
            fetchGroup: async function () {
                let groupId = this.$route.params.group_id

                if (groupId !== undefined) {
                    await fb.groupsCollection
                        .doc(groupId)
                        .get()
                        .then((group) => {
                            this.group = group.data()
                            this.devices = this.group.devices
                        })

                    this.devices.forEach(async device => {
                        await fb.settingsCollection
                            .doc('castles_' + device + '@kineticsmart.com')
                            .get()
                            .then((doc) => {
                                if (doc.data()["autoupdate.s3-prefix"] === "autoupdate/191105-patch") {
                                    Vue.set(this.stagedDevices, device, device)
                                }
                                if (doc.data()["autoupdate.s3-prefix"] === "autoupdate/191106") {
                                    Vue.set(this.preparedDevices, device, device)
                                }
                            })

                        await fb.statusesCollection
                            .where('id', '==', 'castles_' + device + '@kineticsmart.com')
                            .orderBy('timestamp', 'desc')
                            .limit(1)
                            .get()
                            .then((statuses) => {
                                if (!statuses.empty) {
                                    statuses.forEach((status) => {
                                        let doc = status.data()
                                        if (doc["version"] === '1.0.1gb5k' || doc["version"] === '1.0.1gb5a') {
                                            fb.settingsCollection
                                                .doc('castles_' + device + '@kineticsmart.com')
                                                .get()
                                                .then((doc) => {
                                                    let docData = doc.data()
                                                    docData["autoupdate.s3-endpoint"] = "kineticsmart.com"
                                                    docData["autoupdate.s3-bucket-name"] = "goodbox"
                                                    docData["autoupdate.s3-prefix"] = "autoupdate/191105-patch"

                                                    docData["device.show_name"] = true

                                                    docData["device.name"] = "Disabled- Please call 08081961808"
                                                    docData["merchant.api_only"] = true

                                                    docData['autoupdate.latest_update'] = Math.floor(Date.now() / 1000)
                                                    fb.settingsCollection.doc('castles_' + device + '@kineticsmart.com').set(docData, {merge: true})
                                                    Vue.set(this.versionsgb5k, device, docData['header.line1'])
                                                })
                                        }

                                        if (doc["version"] === '1.0.1gb5k-patch') {
                                            fb.settingsCollection
                                                .doc('castles_' + device + '@kineticsmart.com')
                                                .get()
                                                .then((doc) => {

                                                    let docData = doc.data()
                                                    docData['autoupdate.s3-prefix'] = 'autoupdate/191106'
                                                    docData['autoupdate.latest_update'] = Math.floor(Date.now() / 1000)
                                                    fb.settingsCollection.doc('castles_' + device + '@kineticsmart.com').set(docData, {merge: true})

                                                })

                                            Vue.set(this.versionsgb5patch, device, doc["version"])
                                        }

                                        if (doc["version"] === '1.0.1gb5m') {
                                            Vue.set(this.versionsgb5m, device, doc["version"])
                                        }
                                    })
                                }
                            })
                    })
                }

            }
        }
    }
</script>

<style scoped>

</style>
